module.exports = __webpack_public_path__ + "img/1520110241.ba687628.jpg";